import { useState } from 'react';
import { OwnerSimpleSelectionList } from './OwnersSimpleSelectionList';
import { OwnerFilterInput, PageSizeOption } from '@/graphql/generated';
import { OwnerFilters, initialOwnerFilters } from './OwnerFilters';
import { Pagination } from '../molecules';
import textsData from '@/textData/CreateContractsTexts.json';
import { useUserLanguage, useCreateOwnerContractContext } from '@/customHooks';

export const SelectOwnerContractOwnerMenu = () => {
  const { setOwner } = useCreateOwnerContractContext();
  const userLanguage = useUserLanguage();
  const [filters, setFilters] = useState<OwnerFilterInput>(initialOwnerFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataCount, setCurrentDataCount] = useState(0);

  const showPagination = currentDataCount > 0;

  const rootTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = rootTexts.ownerContract.selectOwner;

  const handleFilterChange = (newFilters: OwnerFilterInput) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setFilters({ ...filters, page: page.toString() });
  };

  const handleOwnerSelected = (owner: { id: string; firstName: string; lastName: string }) => {
    setOwner(owner.id, `${owner.firstName} ${owner.lastName}`);
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-5xl">
        <div className="flex flex-col gap-6">
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{texts.title}</h2>
            <p className="text-sm text-gray-500">{texts.helper}</p>
          </div>

          <OwnerFilters filters={filters} onFilterChange={handleFilterChange} />

          <OwnerSimpleSelectionList
            filters={{ ...filters, page: currentPage.toString() }}
            selected={handleOwnerSelected as any}
            onDataCountChange={setCurrentDataCount}
          />

          {showPagination && (
            <div className="flex justify-center mt-4">
              <Pagination
                currentPage={currentPage}
                onPageChange={handlePageChange}
                currentDataCount={currentDataCount}
                pageSize={filters.pageSize || PageSizeOption.TwentyFive}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
